/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-return */
import { Directive, AfterViewInit, Output, Input, EventEmitter, OnChanges, OnInit, SimpleChanges, ElementRef } from '@angular/core';
import { inject } from '@angular/core';
import { ViewContainerRef, ComponentRef } from '@angular/core';
import { DxDataGridComponent } from 'devextreme-angular';
import { default as DxDataGrid, SelectAllMode, dxDataGridColumn, ExportingEvent } from 'devextreme/ui/data_grid';
import { default as dxSelectBox } from 'devextreme/ui/select_box';
import { CurrentUserService, UserSettingsService } from '../../user/services';
import { GridStateService } from './';
import { BizGridSelectionCountComponent } from './biz-grid-selection-count.component';
import { GenericModalService, ModalSettingsTemplate } from '../generic-modal/generic-modal.service';
import { ViewState } from './biz-grid-viewstate';
import { BizGridSaveDialogComponent } from './biz-grid-save-dialog/biz-grid-save-dialog.component';
import { Workbook } from 'exceljs';
import { exportDataGrid } from 'devextreme/excel_exporter';
import { saveAs } from 'file-saver';

export interface ViewStateChangeEvent {
    viewState: ViewState;
    extra?: any;
}

@Directive({
    // eslint-disable-next-line @angular-eslint/directive-selector
    selector: 'dx-data-grid[biz-grid]'
})
export class BizDataGridDirective implements OnInit, AfterViewInit, OnChanges {
    @Output() public rowClick: EventEmitter<any> = new EventEmitter();
    @Output() public rowDoubleClick: EventEmitter<any> = new EventEmitter();
    @Output() public bizOnToolbarPreparing: EventEmitter<any> = new EventEmitter();
    @Output() public bizSetCustomOptions: EventEmitter<any> = new EventEmitter();
    @Output() public bizViewStateChanging: EventEmitter<ViewStateChangeEvent> = new EventEmitter();
    @Output() public bizViewStateChanged: EventEmitter<ViewStateChangeEvent> = new EventEmitter();

    /*
     * Fired when the reset-button has been fired. Use this if you have any custom stage-storing (eg. tracking-columns)
     */
    @Output() public bizGridReset: EventEmitter<any> = new EventEmitter();

    // Delegate to invoke when the refresh button is clicked
    // eslint-disable-next-line @angular-eslint/no-output-on-prefix
    @Output() public onRefresh: EventEmitter<any> = new EventEmitter();

    @Input() public stateStorageKey: string;
    @Input() public viewStateKey: string;
    @Input() public viewStateTrackingFieldPrefix: string;
    @Input() public viewStateExcludedColumns: string[] = [];
    @Input() public exportFileName: string;
    @Input() public summaryDataField: string;
    @Input() public showIsLoading: boolean;
    @Input() public showResetButton = true;
    @Input() public showRefreshButton = true;
    @Input() public showCollapseAllButton = false;
    @Input() public bizSetRemoteOperations = false;
    @Input() public bizSetSummary = true;
    @Input() public bizSetRowAlternationEnabled = true;
    @Input() public bizSetSearchPanel = true;
    @Input() public bizSetHeaderFilter = true;
    @Input() public bizSetGroupPanel = true;
    @Input() public bizSetGroupSummary = true;
    @Input() public bizSetScrolling = true;
    @Input() public bizSetPager = true;
    @Input() public bizSetPaging = true;
    @Input() public bizSetExport = true;
    @Input() public bizSetStateStoring = true;
    @Input() public bizSetColumnChooser = true;
    @Input() public bizSetAllowColumnReordering = true;
    @Input() public bizSetAllowColumnResizing = true;
    @Input() public bizSetOnRowClick = true;
    @Input() public bizAutoExpandGroups = false;
    @Input() public bizAutoWidth = true;
    @Input() public bizHideSelectedRowsComponent = false;
    @Input() public bizHoverStateEnabled = true;
    @Input() public bizRowsSelectedTemplate = '';
    @Input() public bizCancelEditOnEscape = true;
    @Input() public bizEditRowOnDoubleClick = false;
    @Input() public bizHideSelectedRowsCompnent = false;

    private modalService = inject(GenericModalService);
    private viewContainerRef = inject(ViewContainerRef);
    private dataGrid = inject(DxDataGridComponent);
    private gridStateService = inject(GridStateService);
    private userSettingsService = inject(UserSettingsService);
    private currentUserService = inject(CurrentUserService);
    private hostElementRef = inject<ElementRef<HTMLElement>>(ElementRef);

    public stateStorageKeyPreFix = 'dx-data-grid-state_';
    public viewStateStorageKeyPreFix = 'dx-data-grid-viewState_';

    public toolbarInitialized = false;
    public instance: DxDataGrid;
    public selectedRowCounter = { selectedRows: 0 };
    public dropDownSaveItems: string[] = ['Save', 'Save as...', 'Delete...'];

    private bizGridSelectionCountComponent: ComponentRef<BizGridSelectionCountComponent>;
    private pageSizes = [20, 30, 50, 100, 500, 1000];
    private pageSizeSelectBox = null;
    private groupsExpanded = false;

    private viewStateSelectBox: dxSelectBox = null;
    private viewStateDefault: ViewState = { Id: -1, UsersId: null, Name: '(Default)', Key: null, IsSystemConfiguration: true, ShowTrackingFields: true, Configuration: null };
    private viewStates: ViewState[] = [this.viewStateDefault];
    private viewStateSelected = this.viewStateDefault.Id;
    private viewGridConfiguration = false;

    ngOnInit(): void {
        this.viewGridConfiguration = this.currentUserService.hasPermission('Tracking_View_Search_Views');
        if (this.viewStateKey && this.viewGridConfiguration) {
            void this.gridStateService.getViewStates(this.viewStateKey).then(e => {
                this.setNewViewStates(e);

                const key = this.viewStateStorageKeyPreFix + this.viewStateKey;
                const state = this.gridStateService.getState(key);
                if (state?.id && state.name) {
                    this.selectViewState(state.id);
                }
            });
        }

        if (!this.bizHideSelectedRowsComponent) {
            this.bizGridSelectionCountComponent = this.viewContainerRef.createComponent(BizGridSelectionCountComponent);
            if (this.bizHideSelectedRowsCompnent) {
                const componentIndex = this.viewContainerRef.indexOf(this.bizGridSelectionCountComponent.hostView);
                if (componentIndex !== -1) {
                    this.viewContainerRef.detach(componentIndex);
                }
            }
            // if (!this.bizHideSelectedRowsCompnent) {
            //     this.bizGridSelectionCountComponent.changeDetectorRef.detectChanges();
            // }
        }
    }

    ngAfterViewInit(): void {
        if (this.showIsLoading) {
            this.showLoadingPanel();
        }

        // Important that this is called before the other options!
        this.dataGrid.instance.option('onToolbarPreparing', (e) => {

            if (this.viewStateKey && this.viewGridConfiguration) {
                e.toolbarOptions.items.unshift({
                    location: 'after',
                    widget: 'dxButton',
                    name: 'saveStateList',
                    options: {
                        icon: 'save',
                        hint: 'Save current grid configuration',
                        onClick: () => this.saveViewState(),
                    }
                });
                e.toolbarOptions.items.unshift({
                    location: 'after',
                    widget: 'dxSelectBox',
                    name: 'stateList',
                    options: {
                        width: '15em',
                        items: this.viewStates,
                        value: this.viewStateSelected,
                        valueExpr: 'Id',
                        displayExpr: 'Name',
                        hint: 'Choose a previously stored view',
                        onInitialized: $event => this.viewStateSelectBox = $event.component,
                        onValueChanged: $event => {
                            const id = Number($event.value);
                            if (id !== this.viewStateSelected) {
                                this.selectAndApplyViewState(id);
                            }
                        },
                    }
                });
            }

            if (this.bizSetPager) {
                e.toolbarOptions.items.unshift({
                    location: 'after',
                    widget: 'dxSelectBox',
                    name: 'pageSizer',
                    options: {
                        items: this.pageSizes,
                        value: this.pageSizes[0],
                        hint: 'Page size',
                        width: '6em',
                        elementAttr: { class: 'pageSizer' },
                        onInitialized: (evt: any) => { this.pageSizeSelectBox = evt.component; },
                        onValueChanged: (evt: any) => { this.dataGrid.instance.pageSize(evt.value); },
                    }
                });
            }

            if (this.bizRowsSelectedTemplate) {
                e.toolbarOptions.items.unshift({
                    location: 'after',
                    template: this.bizRowsSelectedTemplate,
                    counter: this.selectedRowCounter,
                });
            }

            if (this.showCollapseAllButton) {
                e.toolbarOptions.items.push({
                    location: 'after',
                    widget: 'dxButton',
                    name: 'collapseAllButton',
                    options: {
                        icon: this.groupsExpanded ? 'chevrondown' : 'chevronnext',
                        hint: this.groupsExpanded ? 'Collapse All' : 'Expand All',
                        onClick: this.collapseAllClick.bind(this)
                    }
                });
            }

            if (this.showResetButton) {
                e.toolbarOptions.items.push({
                    location: 'after',
                    widget: 'dxButton',
                    name: 'resetButton',
                    options: {
                        icon: 'repeat',
                        hint: 'Reset the state of the grid (sorting, grouping, filtering, etc.)',
                        onClick: this.reset.bind(this, false)
                    }
                });
            }

            if (this.showRefreshButton && this.onRefresh.observers.length > 0) {
                e.toolbarOptions.items.push({
                    location: 'after',
                    widget: 'dxButton',
                    name: 'refreshButton',
                    options: {
                        icon: 'refresh',
                        hint: 'Refresh the data of the grid',
                        onClick: this.refreshGrid.bind(this)
                    }
                });
            }

            this.bizOnToolbarPreparing.emit(e); // Pass it on to other listeners...
            this.toolbarInitialized = true;
        });

        this.dataGrid.instance.option('columnResizingMode', 'widget');
        this.dataGrid.instance.option('columnAutoWidth', this.bizAutoWidth);
        this.dataGrid.instance.option('hoverStateEnabled', this.bizHoverStateEnabled);

        this.dataGrid.instance.option('onEditorPreparing', e => {
            if (e.parentType === 'dataRow' && this.bizCancelEditOnEscape) {
                e.editorOptions.onInitialized = arg => {
                    arg.component.registerKeyHandler('escape', () => e.component.cancelEditData());
                };
            }
        });

        let grouping = this.dataGrid.instance.option('grouping');
        grouping = grouping || {};
        grouping.autoExpandAll = this.bizAutoExpandGroups;
        this.dataGrid.instance.option('grouping', grouping);
        this.groupsExpanded = this.bizAutoExpandGroups;

        if (this.bizSetRemoteOperations) {
            this.dataGrid.instance.option('remoteOperations', false);
        }

        if (this.bizSetRowAlternationEnabled) {
            this.dataGrid.instance.option('rowAlternationEnabled', true);
        }

        if (this.bizSetSearchPanel) {
            this.dataGrid.instance.option('searchPanel', {
                visible: true,
                width: 240,
                placeholder: 'Search'
            });
        }

        if (this.bizSetHeaderFilter) {
            this.dataGrid.instance.option('headerFilter', { visible: true });
        }

        if (this.bizSetGroupPanel) {
            this.dataGrid.instance.option('groupPanel', { visible: true });
        }

        if (this.bizSetScrolling) {
            this.dataGrid.instance.option('scrolling', { mode: 'standard' });
        }

        if (this.bizSetPager) {
            this.dataGrid.instance.option('pager', {
                showPageSizeSelector: true,
                showNavigationButtons: true,
                allowedPageSizes: this.pageSizes,
                showInfo: true
            });
        }

        if (this.bizSetPaging) {
            this.dataGrid.instance.option('paging', {
                pageSize: 100
            });
        }

        this.setExport();

        if (this.bizSetStateStoring && this.stateStorageKey) {
            this.dataGrid.instance.option('stateStoring', {
                enabled: true,
                type: 'custom',
                savingTimeout: 500,
                customLoad: () => Promise.resolve(this.loadGridState()),
                customSave: state => this.saveGridState(state),
            });
        }

        if (this.bizSetColumnChooser) {
            this.dataGrid.instance.option('columnChooser', {
                enabled: true,
                mode: 'select',
                sortOrder: 'asc',
                height: '60rem',
                width: '50rem',
                position: {
                    my: 'top',
                    at: 'top',
                    of: this.hostElementRef.nativeElement
                },
                search: {
                    enabled: true,
                    editorOptions: {
                        placeholder: 'Filter columns'
                    }
                },
                selection: {
                    allowSelectAll: true,
                    selectByClick: true,
                }
            });
        }

        this.removeButtonColumnsFromColumnChooser();

        if (this.bizSetAllowColumnReordering) {
            this.dataGrid.instance.option('allowColumnReordering', true);
        }

        if (this.bizSetAllowColumnResizing) {
            this.dataGrid.instance.option('allowColumnResizing', true);
        }

        if (this.bizSetOnRowClick) {
            this.dataGrid.instance.option('onRowClick', (clickedRow: any) => {
                if (clickedRow.rowType === 'data') {
                    const component = clickedRow.component;
                    const prevClickTime = component.lastClickTime;
                    component.lastClickTime = new Date();
                    if (prevClickTime && (component.lastClickTime - prevClickTime < 300)) {
                        let allowEdit = !this.dataGrid.editing || this.dataGrid.editing.allowUpdating === true; // Allow edit by default if no editing is configured.
                        if (!allowEdit && typeof this.dataGrid.editing.allowUpdating === 'function') {
                            allowEdit = this.dataGrid.editing.allowUpdating({ component: this.dataGrid.instance, row: clickedRow });
                        }

                        if (allowEdit && this.bizEditRowOnDoubleClick && this.dataGrid.editing.allowUpdating) {
                            this.dataGrid.instance.editRow(clickedRow.rowIndex);
                        }
                        this.rowDoubleClick.emit(clickedRow.data);
                    }
                    else {
                        this.rowClick.emit(clickedRow.data);
                    }
                }
            });
        }

        this.setSummary();
        this.dataGrid.instance.on('selectionChanged', (e) => {
            if (this.bizSetSummary && this.bizGridSelectionCountComponent) {
                const selectedRows = e.selectedRowsData.length;
                this.bizGridSelectionCountComponent.instance.numberOfSelectedRows = selectedRows;
                this.selectedRowCounter.selectedRows = selectedRows;
            }
        });

        this.dataGrid.instance.on('contentReady', (_e: any) => {
            this.removeButtonColumnsFromColumnChooser();
            if (this.pageSizeSelectBox) {
                const currentPageSize = this.dataGrid.instance.pageSize();
                this.pageSizeSelectBox.option('value', currentPageSize);
            }
        });

        this.dataGrid.instance.on('exporting', (e: ExportingEvent) => {
            const workbook = new Workbook();
            const worksheet = workbook.addWorksheet('Sheet');
            let filename = 'LinkGridExport.xlsx';
            if (this.exportFileName.length > 0) {
                filename = this.exportFileName + '.xlsx';
            }
            exportDataGrid({
                component: e.component,
                worksheet: worksheet
            }).then(function () {
                void workbook.xlsx.writeBuffer()
                    .then(function (buffer: BlobPart) {
                        saveAs(new Blob([buffer], { type: 'application/octet-stream' }), filename);
                    });
            });
        });

        this.instance = this.dataGrid.instance;
        void this.checkSelectionMode();
        this.bizSetCustomOptions.emit();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.showIsLoading) {
            if (this.showIsLoading) {
                this.showLoadingPanel();
            }
            else {
                this.hideLoadingPanel();
            }
        }
        if (changes.exportFileName) {
            this.setExport();
        }
    }

    public loadGridState(): any {
        const key = this.stateStorageKeyPreFix + this.stateStorageKey;
        return this.gridStateService.getState(key);
    }

    public saveGridState(state: any): void {
        const key = this.stateStorageKeyPreFix + this.stateStorageKey;
        this.gridStateService.setState(key, state);
    }

    private setExport(): void {
        if (this.bizSetExport && this.exportFileName && !!this.dataGrid?.instance) {
            this.dataGrid.instance.option('export', {
                enabled: true,
                allowExportSelectedData: true
            });
        }
    }

    /**
     * Call this method to add the summaries
     */
    public setSummary(): void {
        const visibleColumns = this.dataGrid && this.dataGrid.columns
            ? this.dataGrid.columns.filter((c: dxDataGridColumn) => c.visible) as dxDataGridColumn[]
            : [];

        if (visibleColumns.length > 0) {

            if (this.bizSetSummary) {

                this.dataGrid.instance.option('summary', {
                    totalItems: [{
                        column: this.summaryDataField || visibleColumns[0].dataField,
                        summaryType: 'count',
                        displayFormat: 'Number of rows: {0}'
                    }]
                });
            }

            if (this.bizSetGroupSummary) {
                let existingSummary = this.dataGrid.instance.option('summary');
                if (!existingSummary) {
                    existingSummary = {};
                }

                if (!existingSummary.groupItems) {
                    existingSummary.groupItems = [];
                }

                if (!existingSummary.groupItems.some(g => g.name === 'bizGridGroupSummary')) {
                    existingSummary.groupItems.push({
                        name: 'bizGridGroupSummary',
                        column: this.summaryDataField || visibleColumns[0].dataField,
                        summaryType: 'count',
                        displayFormat: '{0} rows'
                    });
                }
            }
        }
    }

    /**
     * Clear the grid for filters, grouping, selection, sorting, etc.
     * The data is not touched.
     */
    public reset(keepState: boolean = true): void {
        const previousViewState = this.viewStateSelected;

        this.dataGrid.instance.clearFilter();
        this.dataGrid.instance.clearGrouping();
        this.dataGrid.instance.clearSelection();
        this.dataGrid.instance.clearSorting();
        if (!keepState) {
            this.dataGrid.instance.state(null);
        }

        if (this.viewStateKey) {
            this.selectViewState(this.viewStateDefault.Id);
            this.selectAndApplyViewState(previousViewState);
        }

        this.bizGridReset.emit();
    }

    refreshGrid(): void {
        // Invoke the refresh delegate and hide the loading panel
        this.onRefresh.emit();
    }

    public showLoadingPanel(loadingMessage?: string): void {
        if (this.dataGrid.instance && this.dataGrid.instance.beginCustomLoading) {
            this.dataGrid.instance.beginCustomLoading(loadingMessage || 'Loading...');
        }
    }

    public hideLoadingPanel(): void {
        if (this.dataGrid.instance && this.dataGrid.instance.endCustomLoading) {
            this.dataGrid.instance.endCustomLoading();
        }
    }

    public setGridState(state: any) {
        if (this.dataGrid.instance) {
            this.dataGrid.instance.state(state);
        }
    }

    public getGridState(): any {
        return this.dataGrid.instance?.state();
    }

    public async checkSelectionMode(): Promise<void> {
        const setting = await this.userSettingsService.getSingleSetting('Setting_Grid_SelectAllMode');
        if (setting && this.instance) {
            const mode = setting.Value1 as SelectAllMode;
            this.instance.option('selection', { selectAllMode: mode });

            // Force the grid to re-evaluate selection state
            const selectedKeys = this.instance.getSelectedRowKeys();
            this.instance.clearSelection();
            this.instance.selectRows(selectedKeys, true);
        }
    }

    collapseAllClick(e): void {
        this.groupsExpanded = !this.groupsExpanded;
        e.component.option({
            icon: this.groupsExpanded ? 'chevrondown' : 'chevronnext',
            hint: this.groupsExpanded ? 'Collapse All' : 'Expand All'
        });

        if (this.groupsExpanded) {
            this.dataGrid.instance.expandAll(0);
        }
        else {
            this.dataGrid.instance.collapseAll();
        }
    }

    private setNewViewStates(viewStates: ViewState[], selectViewStateId?: number): void {
        if (this.viewStateSelectBox) {
            viewStates = viewStates?.sort((a, b) => a.Name.localeCompare(b.Name)) || [];
            this.viewStates = [this.viewStateDefault, ...viewStates];
            this.viewStateSelectBox.option('items', this.viewStates);
            this.selectAndApplyViewState(selectViewStateId ?? this.viewStateSelected);
        }
    }

    private isExcludedColumn(name: string): boolean {
        return this.viewStateExcludedColumns?.includes(name);
    }

    private async saveViewState(): Promise<void> {
        try {
            const activeViewState = this.viewStates?.find(e => e.Id === this.viewStateSelected);
            const mustCopy = activeViewState.IsSystemConfiguration || !activeViewState.UsersId;

            const currentState = this.dataGrid.instance.state();
            currentState.columns = currentState.columns.filter(column => !this.isExcludedColumn(column.name));

            const newViewState: ViewState = {
                ...activeViewState,
                Id: mustCopy ? null : activeViewState.Id,
                Name: mustCopy ? '' : activeViewState.Name,
                Key: this.viewStateKey,
                Configuration: JSON.stringify(currentState),
                IsSystemConfiguration: false,
            } as ViewState;

            const componentData = {
                viewStateWithTrackingFields: this.viewStateTrackingFieldPrefix?.length > 0,
                viewStates: this.viewStates,
                viewState: newViewState
            };
            const toSaveViewState = await this.modalService.openComponentType<ViewState>(BizGridSaveDialogComponent, componentData, new ModalSettingsTemplate('sm', 'static'));

            // If the name is changed, reset the id to make a copy
            toSaveViewState.Id = toSaveViewState.Name.localeCompare(newViewState.Name) ? 0 : toSaveViewState.Id;

            const savedViewState = await this.gridStateService.saveViewState(toSaveViewState);

            // Update list and select the newly saved view state
            void this.gridStateService.getViewStates(this.viewStateKey).then(e => {
                this.viewStateSelected = -2; // Ensure that new or updated view is applied even if it's the current state
                this.setNewViewStates(e, savedViewState.Id);
            });
        }
        catch {
            // We get here if the dialog is dismissed (canceled)
        }
    }

    public getViewState(id: number): ViewState {
        return this.viewStates.find(e => e.Id === id) ?? this.viewStateDefault;
    }

    public selectViewState(id: number): ViewState {
        const viewState = this.getViewState(id);
        if (this.viewStateKey) {
            this.viewStateSelected = viewState.Id;
            this.viewStateSelectBox?.option('value', viewState.Id);
        }
        return viewState;
    }

    private applyConfiguration(configuration: any, showTrackingFields: boolean): void {
        const currentConfiguration = this.dataGrid.instance.state();
        const newConfiguration = { ...currentConfiguration };

        // Apply column order and visibility
        newConfiguration?.columns?.forEach(element => {
            // Transfer specific properties, including 'undefined' properties from saved configuration onto current state
            const column = configuration?.columns?.find(e => e.name === element.name);
            if (column && !this.isExcludedColumn(column.name)) {
                element.visible = (this.viewStateTrackingFieldPrefix?.length > 0) && ((element.name as string).startsWith(this.viewStateTrackingFieldPrefix))
                    ? showTrackingFields : (column.visible ?? element.visible);
                element.visibleIndex = column.visibleIndex ?? element.visibleIndex;
                element.width = column.width;
                element.groupIndex = column.groupIndex;
                // element.sortOrder = column?.sortOrder;   Sorting is explicitly exempt
                // element.sortIndex = column?.sortIndex;
            }
        });
        this.dataGrid.instance.state(newConfiguration);
        this.saveGridState(this.getGridState());
    }

    private selectAndApplyViewStateInternal(id: number, force: boolean): void {
        if (this.viewStateKey) {
            const alreadySelected = id === this.viewStateSelected;
            const viewState = this.selectViewState(id);
            if (viewState && (!alreadySelected || force)) {
                const viewStateChangeEvent: ViewStateChangeEvent = { viewState };
                try {
                    this.bizViewStateChanging.emit(viewStateChangeEvent);

                    const key = this.viewStateStorageKeyPreFix + this.viewStateKey;
                    this.gridStateService.setState(key, { id: viewStateChangeEvent.viewState.Id, name: viewStateChangeEvent.viewState.Name });
                    if (viewStateChangeEvent.viewState.Id > this.viewStateDefault.Id) {
                        this.applyConfiguration(JSON.parse(viewStateChangeEvent.viewState.Configuration || 'null'), !!viewStateChangeEvent.viewState.ShowTrackingFields);
                    }
                    else {
                        this.dataGrid.instance.state(null);
                    }
                }
                finally {
                    this.bizViewStateChanged.emit(viewStateChangeEvent);
                }
            }
        }
    }

    public selectAndApplyViewState(id: number): void {
        this.selectAndApplyViewStateInternal(id, false);
    }

    public reapplyViewState(): void {
        this.selectAndApplyViewStateInternal(this.viewStateSelected, true);
    }

    private removeButtonColumnsFromColumnChooser(): void {
        const columns = this.dataGrid.instance?.option('columns') as dxDataGridColumn[];
        if (!Array.isArray(columns)) {
            return;
        }

        columns.forEach((column, index) => {
            const columnType = column?.type as string;
            if (columnType !== 'buttons') {
                return;
            }

            const columnIdentifier = column?.name ?? column?.dataField ?? index;
            const showInColumnChooser = this.dataGrid.instance.columnOption(columnIdentifier, 'showInColumnChooser');
            if (showInColumnChooser !== false) {
                this.dataGrid.instance.columnOption(columnIdentifier, 'showInColumnChooser', false);
            }
        });
    }
}
